<div class="crm-page">
  <app-header
    [title]="'TITLES.CONTACTS' | translate"
    [subtitle]="'COMPONENTS.CONTACTS.SUBTITLE' | translate"
  >
    <div header-actions class="crm-page__header-actions">
      <div class="hidden lg:block">
        <app-navbar-profile-info></app-navbar-profile-info>
      </div>
    </div>
  </app-header>

  <div class="crm-page__content px-4 md:px-8 py-6 md:py-8">
    @if (isLoading) {
      <div class="crm-page__overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ "MESSAGES.LOADING" | translate }}</span>
        </div>
      </div>
    }

    <div class="crm-page__toolbar">
      <div class="crm-list-search form-search">
        <div class="input-search">
          <input
            type="text"
            [value]="searchTerm"
            [placeholder]="'COMPONENTS.CONTACTS.SEARCH_PLACEHOLDER' | translate"
            [attr.aria-label]="'COMPONENTS.CONTACTS.SEARCH_PLACEHOLDER' | translate"
            (input)="onSearchChange($any($event.target).value)"
          />
          <span class="search-icon" aria-hidden="true">
            <img src="assets/img/search.svg" alt="" />
          </span>
        </div>
      </div>

      @if (canCreateContact$ | async) {
        <div class="crm-page__toolbar-actions">
          <button
            type="button"
            class="crm-page__action-button crm-import-button"
            (click)="openImport()"
          >
            <span class="crm-import-button-icon" aria-hidden="true">
              <svg focusable="false" viewBox="0 0 16 16">
                <path
                  d="M8 1.5a.5.5 0 0 1 .5.5v6.293l2.146-2.147a.5.5 0 1 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 8.293V2a.5.5 0 0 1 .5-.5Zm-5 10A1.5 1.5 0 0 0 4.5 13h7A1.5 1.5 0 0 0 13 11.5v-.5a.5.5 0 0 1 1 0v.5A2.5 2.5 0 0 1 11.5 14h-7A2.5 2.5 0 0 1 2 11.5v-.5a.5.5 0 0 1 1 0v.5Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span class="crm-import-button-label">
              {{ "BUTTONS.IMPORT" | translate }}
            </span>
          </button>
          <button
            id="add-contact-container"
            type="button"
            class="crm-page__action-button crm-page__action-button--primary"
            (click)="openCreateContactModal()"
          >
            + {{ "BUTTONS.ADD_CONTACT" | translate }}
          </button>
        </div>
      }
    </div>

    @if (contacts$ | async; as contacts) {
      @if (contacts.items.length === 0) {
        <app-card-shell class="crm-page__empty-card" padding="none">
          <div class="crm-page__empty-state">
            <app-empty-content
              [showImage]="true"
              [message]="
                'MESSAGES.EMPTY_LIST'
                  | translate: { param: emptyContactListParam[currentLang] }
              "
              [tooltip]="'TOOLTIPS.EMPTY_CONTACT_LIST' | translate"
              [textPositionClass]="'text-center'"
            />
          </div>
        </app-card-shell>
      } @else {
        <app-card-shell class="crm-page__list-card" padding="none">
          <div class="crm-table__desktop">
            <div class="crm-table__scroller">
              <table class="crm-table__table">
                <thead>
                  <tr class="crm-table__header-row">
                    <th class="crm-table__header-cell crm-table__header-cell--type"></th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="fullName"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.FULL_NAME" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="organizationTitle"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.ORGANIZATION" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="email"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.EMAIL" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="phoneNumber"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.PHONE_NUMBER" | translate }}
                    </th>
                    <th class="crm-table__header-cell">
                      {{ "TABLE_HEADERS.BIRTHDATE" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="responsibleUserName"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "TABLE_HEADERS.RESPONSIBLE" | translate }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  @for (contact of contacts.items; track contact.id) {
                    <tr class="crm-table__row">
                      <td class="crm-table__cell crm-table__cell--type">
                        <ng-container
                          [ngTemplateOutlet]="entityTypeIcon"
                          [ngTemplateOutletContext]="{ contact: contact }"
                        ></ng-container>
                      </td>
                      <td class="crm-table__cell crm-table__cell--title">
                        <a [routerLink]="contact.id" [title]="contact.fullName">
                          {{ contact.fullName }}
                        </a>
                      </td>
                      <td class="crm-table__cell">
                        @if (contact.hasOrganization) {
                          <a
                            [routerLink]="['../organizations', contact.organizationId]"
                            [title]="contact.organizationTitle"
                          >
                            {{ contact.organizationTitle }}
                          </a>
                        } @else {
                          <span class="crm-table__muted">-</span>
                        }
                      </td>
                      <td class="crm-table__cell" [title]="contact.email">{{ contact.email || "-" }}</td>
                      <td class="crm-table__cell" [title]="contact.phoneNumber">
                        {{ contact.phoneNumber || "-" }}
                      </td>
                      <td class="crm-table__cell" [title]="contact.birthDate || '-'">
                        {{ contact.birthDate ? (contact.birthDate | date: "mediumDate") : "-" }}
                      </td>
                      <td class="crm-table__cell">
                        @if (contact.hasResponsibleUser) {
                          <button
                            type="button"
                            class="crm-table__profile-button"
                            [title]="contact.responsibleUserName"
                            (click)="viewProfile(contact.responsibleUserId)"
                          >
                            {{ contact.responsibleUserName }}
                          </button>
                        } @else {
                          <span class="crm-table__muted">-</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          <div class="crm-page__footer contacts-page__footer--desktop">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="contacts.totalCount"
              [page]="contacts.page"
              [pageSize]="contacts.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </app-card-shell>

        <div class="crm-table__mobile-section">
          <div class="crm-table__mobile-list">
            @for (contact of contacts.items; track contact.id) {
              <article class="crm-mobile-card">
                <div class="crm-mobile-card__header">
                  <div class="crm-mobile-card__title-wrap">
                    <ng-container
                      [ngTemplateOutlet]="entityTypeIcon"
                      [ngTemplateOutletContext]="{ contact: contact }"
                    ></ng-container>

                    <div class="crm-mobile-card__title-block">
                      <a
                        class="crm-mobile-card__title"
                        [routerLink]="contact.id"
                        [title]="contact.fullName"
                      >
                        {{ contact.fullName }}
                      </a>
                    </div>
                  </div>
                </div>

                <div class="crm-mobile-card__grid">
                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">{{ "TABLE_HEADERS.ORGANIZATION" | translate }}</p>
                    @if (contact.hasOrganization) {
                      <a
                        class="crm-mobile-card__title"
                        [routerLink]="['../organizations', contact.organizationId]"
                        [title]="contact.organizationTitle"
                      >
                        {{ contact.organizationTitle }}
                      </a>
                    } @else {
                      <p class="crm-mobile-card__value crm-table__muted">-</p>
                    }
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">{{ "TABLE_HEADERS.EMAIL" | translate }}</p>
                    <p class="crm-mobile-card__value">{{ contact.email || "-" }}</p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">{{ "TABLE_HEADERS.PHONE_NUMBER" | translate }}</p>
                    <p class="crm-mobile-card__value">{{ contact.phoneNumber || "-" }}</p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">{{ "TABLE_HEADERS.BIRTHDATE" | translate }}</p>
                    <p class="crm-mobile-card__value">
                      {{ contact.birthDate ? (contact.birthDate | date: "mediumDate") : "-" }}
                    </p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">{{ "TABLE_HEADERS.RESPONSIBLE" | translate }}</p>
                    @if (contact.hasResponsibleUser) {
                      <button
                        type="button"
                        class="crm-table__profile-button crm-table__profile-button--mobile"
                        [title]="contact.responsibleUserName"
                        (click)="viewProfile(contact.responsibleUserId)"
                      >
                        {{ contact.responsibleUserName }}
                      </button>
                    } @else {
                      <p class="crm-mobile-card__value crm-table__muted">-</p>
                    }
                  </div>
                </div>
              </article>
            }
          </div>

          <div class="crm-page__footer contacts-page__footer--mobile">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="contacts.totalCount"
              [page]="contacts.page"
              [pageSize]="contacts.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </div>
      }
    }

    <app-reusable-modal
      [isOpen]="isCreateContactModalOpen"
      [panelClass]="'max-w-4xl'"
      [contentScoped]="true"
      [title]="'TITLES.ADD_CONTACT' | translate"
      [subtitle]="'COMPONENTS.CONTACTS.CREATE_MODAL_SUBTITLE' | translate"
      (closed)="closeCreateContactModal()"
    >
      <app-create-contact
        [companyId]="companyId"
        [isShownOrganization]="(canViewOrganizations$ | async) ?? false"
        (cancelled)="closeCreateContactModal()"
        (created)="onContactCreated()"
      />
    </app-reusable-modal>
  </div>
</div>

<ng-template #entityTypeIcon let-contact="contact">
  <span
    class="crm-table__type-badge"
    [class.crm-table__type-badge--regular]="contact.entityType === 'regular'"
    [class.crm-table__type-badge--customer]="contact.entityType === 'customer'"
    [class.crm-table__type-badge--vendor]="contact.entityType === 'vendor'"
    [title]="contact.entityTypeTitle"
  >
    @switch (contact.entityType) {
      @case ('customer') {
        <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
          <path
            d="M0 1.5A.5.5 0 0 1 .5 1h1a.5.5 0 0 1 .49.402L2.89 6h10.72a.5.5 0 0 1 .48.637l-1.2 4A.5.5 0 0 1 12.41 11H4.1a.5.5 0 0 1-.49-.402L1.61 2H.5A.5.5 0 0 1 0 1.5zM5 12.5A1.5 1.5 0 1 0 5 15.5 1.5 1.5 0 0 0 5 12.5zm6 0A1.5 1.5 0 1 0 11 15.5 1.5 1.5 0 0 0 11 12.5z"
          />
        </svg>
      }
      @case ('vendor') {
        <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
          <path
            d="M6.5 0a.5.5 0 0 0-.5.5V2H3a2 2 0 0 0-2 2v2h14V4a2 2 0 0 0-2-2h-3V.5a.5.5 0 0 0-.5-.5h-3zM7 2V1h2v1H7zM1 7v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7H1zm3.5 2.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1z"
          />
        </svg>
      }
      @default {
        <svg aria-hidden="true" focusable="false" viewBox="0 0 16 16">
          <path
            d="M8 0a5 5 0 1 0 0 10A5 5 0 0 0 8 0zm0 11c-3.314 0-6 1.343-6 3v1h12v-1c0-1.657-2.686-3-6-3z"
          />
        </svg>
      }
    }
  </span>
</ng-template>
